import type { DtoApplication } from "@porchpass/api-client";
import type { RenderDashboardParams } from "src/types/dashboard";

export const renderDashboard = (
  response: DtoApplication[],
  {
    setApplications,
    setIsLoading,
    navigate,
    dealerName,
  }: RenderDashboardParams,
) => {
  console.log("Loading application dashboard");
  setApplications(response);
  setIsLoading(false);
  navigate(`/${dealerName}/dashboard`, { replace: true });
};
